<template>
  <span class="day-tag">
    <p class="inner-tag-text"><slot></slot></p>
  </span>
</template>

<script>
export default {
    name: "PrimaryTag"
}
</script>


<style lang="scss" scoped>
.day-tag {
    color: #F9A168;
    background: #FFF9F4;
    border-radius: 25px;
    padding: 4px 10px;
    padding-top: 7px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 19px;
    text-align: center;
    text-transform: capitalize;
    border: 1px solid #F9A168;
    margin-bottom: 4px;
    margin-right: 4px;
    display: inline-block;
		// cursor: pointer;
    .inner-tag-text {
        text-align: center;
    }
}
</style>
